// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EC4Xd","input":"styles_input__3TYsp"};